<template>
	<div class="remindset" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
		<div class="card-content" :style="{ height: `${windowHeight - 110}px` , 'overflow-y': 'auto' }">
			<div class="item" v-for="(item, index) in link" :key="index">
				<div class="second-item">
					<div class="second-header">
						<span>{{ item.name }}</span>
					</div>
					<div class="second-body">
						<div class="second-item" v-for="(i, secondIndex) in item.sonlink" :key="secondIndex">
							<span class="second-cbx">{{ i.name }}</span>
							<div class="lastBox">
								<div class="last-item" v-if="i.sonlink.length > 0" v-for="(sonItem, lastIndex) in i.sonlink" :key="lastIndex">
									<span class="second-cbx">{{ sonItem.name }}</span>
									<div v-if="sonItem.sonlink.length > 0" style="width:100%">
										<div class="last-item" v-for="(son, sonindex) in sonItem.sonlink" :key="sonindex">
											 <span v-if="son.sonlink.length>1" class="second-cbx2">{{ son.name }}</span>
											 <span v-if="son.sonlink.length==1" class="second-cbx">{{ son.name }}</span>
											 <div v-if="son.sonlink.length > 0" style="clear:both; width:100%;">
												<div class="last-item" v-for="(son1, idx1) in son.sonlink" :key="idx1">
													<span class="second-cbx">{{ son1.name }}</span>
													 <div v-if="son1.sonlink.length== 0"  style="clear:both; width:100%;">
														<el-row class="row">
															<el-col :span="5">
																<el-switch v-model="son1.remind_self" active-color="#13ce66" active-value="1" inactive-value="0" @change="RemindCreate(son1)"></el-switch>
																提醒创建人
															</el-col>
															<el-col :span="5">
																<el-switch v-model="son1.remind_parent" active-color="#13ce66" active-value="1" inactive-value="0" @change="RemindParent(son1)"></el-switch>
																提醒上级
															</el-col>
															<el-col :span="4"><el-button type="warning" size="mini" :plain="btnplain" @click="SetReceiver(son1)">固定接收人</el-button></el-col>
															<el-col :span="4"><el-button type="success" size="mini" :plain="btnplain" @click="SetWxTemplate(son1)">设置模板</el-button></el-col> 
												<el-col :span="4"><el-button type="primary" size="mini" :plain="btnplain" @click="SetEmailTemplate(son1)">设置邮件</el-button></el-col> 			
														</el-row>
													 </div> 
												</div>
											</div>
										</div>
									</div>
									<div v-if="sonItem.sonlink.length == 0" class="sonset">
										<el-row class="row">
											<el-col :span="5">
												<el-switch v-model="sonItem.remind_self" active-color="#13ce66" active-value="1" inactive-value="0" @change="RemindCreate(sonItem)"></el-switch>
												提醒创建人
											</el-col>
											<el-col :span="5">
												<el-switch v-model="sonItem.remind_parent" active-color="#13ce66" active-value="1" inactive-value="0" @change="RemindParent(sonItem)"></el-switch>
												提醒上级
											</el-col>
											<el-col :span="4"><el-button type="warning" size="mini" :plain="btnplain" @click="SetReceiver(sonItem)">固定接收人</el-button></el-col>
											<el-col :span="4"><el-button type="success" size="mini" :plain="btnplain" @click="SetWxTemplate(sonItem)">设置模板</el-button></el-col>
											<el-col :span="4"><el-button type="primary" size="mini" :plain="btnplain" @click="SetEmailTemplate(sonItem)">设置邮件</el-button></el-col>
										</el-row>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	<setreceiver ref="setreceiver"></setreceiver>
	<setwxtemp ref="setwxtemp"></setwxtemp>
	<emailtemp ref="selemailtemp"></emailtemp>
	</div>
</template>
<script>
import setreceiver from '@/components/msg/setreceiver_wx.vue';	
import setwxtemp from '@/components/msg/setwxtemp.vue';	
import emailtemp from '@/components/msg/emailtemp.vue';
export default {
	components: {
		setreceiver,
		setwxtemp,
		emailtemp
	},
	data() {
		return {
			btnplain: true,
			windowHeight: window.innerHeight - 10,
			link: [],
			divclass:'remindset'
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/msg/remindset.scss');
			this.getset();
		});
	},
	methods: {
		//获取权限功能选择框
		getset() {
			var that = this;
			this.$tool.loading('正在加载', this.divclass);
			this.$apipost.get.RemindSet_Wx().then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					//console.log('list',res.list);
					that.link = res.list;
				}
			});
		},
		SetWxTemplate(item) {
			//debugger
			if(this.$refs.setwxtemp!=undefined)
				this.$refs.setwxtemp.init({id:item.id});
		},
		//设置固定接收人
		SetReceiver(item) {
			//debugger
			if(this.$refs.setreceiver!=undefined)
				this.$refs.setreceiver.init({id:item.id});
		},
		//设置邮件模板
		SetEmailTemplate(item) {
			//debugger
			if(this.$refs.selemailtemp!=undefined)
				this.$refs.selemailtemp.init({id:item.id,email_id:item.email_id});
		},
		RemindParent(item){
			//debugger
			var paraminfo={
				id:item.id,
				remind_parent:item.remind_parent
			}
			this.$apipost.post.SaveRemindSet({paraminfo:paraminfo}).then(res => {
				if (res != '') {
					if(res.state=='1')
						this.$tool.message('设置成功',1);
					else{
						if(item.remind_parent==0)
							item.remind_parent=1;
						else
							item.remind_parent=0;
					}
				}
			});
		},
		RemindCreate(item){
			//debugger
			var paraminfo={
				id:item.id,
				remind_self:item.remind_self
			}
			this.$apipost.post.SaveRemindSet({paraminfo:paraminfo}).then(res => {
				if (res != '') {
					if(res.state=='1')
						this.$tool.message('设置成功',1);
					else{
						if(item.remind_self==0)
							item.remind_self=1;
						else
							item.remind_self=0;
					}
				}
			});
		},
		RollbackSet(e){
			debugger
			var that=this;
			that.link.forEach(s=>{
				var isset=false;
				if(s.sonlink.length>0){
					s.sonlink.forEach(son=>{
						if(son.sonlink.length>0){
							son.sonlink.forEach(sson=>{
								if(sson.sonlink.length>0){
									sson.sonlink.forEach(ssson=>{
										if(ssson.sonlink.length>0){
											ssson.sonlink.forEach(sssson=>{
												if(sssson.id==e.id){
													isset=true;
													sssson[e.type]=e[e.type];
													return false;
												}	
											});
										}else{
											if(ssson.id==e.id){
												isset=true;
												ssson[e.type]=e[e.type];
												return false;
											}	
										}
									});
								}
								else{
									if(sson.id==e.id){
										isset=true;
										sson[e.type]=e[e.type];
										return false;
									}	
								}
							});
							if(isset)
								return false;
						}
						else{
							if(son.id==e.id){
								isset=true;
								son[e.type]=e[e.type];
							}
						}
						if(isset)
							return false;
					});
				}
				if(isset)
					return false;
			});
		}
	}
};
</script>
<style></style>
